import { render } from "./BetSlipWager.vue?vue&type=template&id=b658228a&scoped=true"
import script from "./BetSlipWager.vue?vue&type=script&lang=js"
export * from "./BetSlipWager.vue?vue&type=script&lang=js"

import "./BetSlipWager.vue?vue&type=style&index=0&id=b658228a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b658228a"]])

export default __exports__